import SubscriptionDetailsSection from './SubscriptionDetailsSection';

export default SubscriptionDetailsSection;
